export const FETCH_CONSOLIDATED_FEEDBACK_REQUEST = 'FETCH_CONSOLIDATED_FEEDBACK_REQUEST';
export const FETCH_CONSOLIDATED_FEEDBACK_SUCCESS = 'FETCH_CONSOLIDATED_FEEDBACK_SUCCESS';
export const FETCH_CONSOLIDATED_FEEDBACK_FAILURE = 'FETCH_CONSOLIDATED_FEEDBACK_FAILURE';

export const FETCH_CONSOLIDATED_FEEDBACK = 'FETCH_CONSOLIDATED_FEEDBACK';

export const POST_MANAGER_RATING_REQUEST = 'POST_MANAGER_RATING_REQUEST';
export const POST_MANAGER_RATING_SUCCESS = 'POST_MANAGER_RATING_SUCCESS';
export const POST_MANAGER_RATING_FAILURE = 'POST_MANAGER_RATING_FAILURE';

export const POST_MANAGER_RATING = 'POST_MANAGER_RATING';

export const PUT_MANAGER_RATING_REQUEST = 'PUT_MANAGER_RATING_REQUEST';
export const PUT_MANAGER_RATING_SUCCESS = 'PUT_MANAGER_RATING_SUCCESS';
export const PUT_MANAGER_RATING_FAILURE = 'PUT_MANAGER_RATING_FAILURE';

export const PUT_MANAGER_RATING = 'PUT_MANAGER_RATING';

export const DELETE_MANAGER_RATING_REQUEST = 'DELETE_MANAGER_RATING_REQUEST';
export const DELETE_MANAGER_RATING_SUCCESS = 'DELETE_MANAGER_RATING_SUCCESS';
export const DELETE_MANAGER_RATING_FAILURE = 'DELETE_MANAGER_RATING_FAILURE';

export const DELETE_MANAGER_RATING = 'DELETE_MANAGER_RATING';

export const CLEAR_RATING_ERROR_NOTIFICATION = 'CLEAR_RATING_ERROR_NOTIFICATION';

export const FETCH_READ_COMMENT_REQUEST = 'FETCH_READ_COMMENT_REQUEST';
export const FETCH_READ_COMMENT_SUCCESS = 'FETCH_READ_COMMENT_SUCCESS';
export const FETCH_READ_COMMENT_FAILURE = 'FETCH_READ_COMMENT_FAILURE';

export const FETCH_READ_COMMENT = 'FETCH_READ_COMMENT';
